// src/components/AssistMenu.jsx
import React from 'react';
import {
  Menu,
  MenuItem,
  Divider,
  ListItemIcon,
  ListItemText
} from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';
import { gradient } from '../../utils/darkModeAdapter';

import RestartAltIcon from '@mui/icons-material/RestartAlt';
import HistoryIcon from '@mui/icons-material/History';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

export default function AssistMenu({
  anchorEl,
  open,
  onClose,
  onRestart,
  onShowHistory,
  onPrevVersion,
  onNextVersion,
  hasPrevVersion,
  hasNextVersion
}) {
  const theme = useTheme();

  // メニュー項目の共通スタイル
  const menuItemStyle = (color = '#fc67fa') => ({
    '&:hover': {
      backgroundColor: alpha(color, 0.1),
    },
    padding: '12px 16px',
    margin: '2px 0',
    borderRadius: '8px',
    '& .MuiListItemIcon-root': {
      color: color,
      minWidth: '40px',
    },
    '& .MuiListItemText-primary': {
      fontWeight: 'bold',
      fontSize: '0.95rem',
    }
  });

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      transformOrigin={{ vertical: 'top', horizontal: 'center' }}
      sx={{
        '& .MuiPaper-root': {
          borderRadius: 2,
          boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
          minWidth: 220,
          padding: '8px',
          background: gradient(theme).menu,
        },
      }}
    >
      <MenuItem onClick={onRestart} sx={menuItemStyle('#f44336')}>
        <ListItemIcon>
          <RestartAltIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>初めからやり直す</ListItemText>
      </MenuItem>

      <Divider sx={{ my: 1, opacity: 0.6 }} />
      
      <MenuItem onClick={onPrevVersion} disabled={!hasPrevVersion} sx={menuItemStyle('#48c6ef')}>
        <ListItemIcon>
          <ArrowBackIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>前の計画に戻る</ListItemText>
      </MenuItem>
      
      <MenuItem onClick={onNextVersion} disabled={!hasNextVersion} sx={menuItemStyle('#48c6ef')}>
        <ListItemIcon>
          <ArrowForwardIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>次の計画に進む</ListItemText>
      </MenuItem>

      <Divider sx={{ my: 1, opacity: 0.6 }} />

      <MenuItem onClick={onShowHistory} sx={menuItemStyle('#4caf50')}>
        <ListItemIcon>
          <HistoryIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>過去の出力結果を確認</ListItemText>
      </MenuItem>

    </Menu>
  );
}